
import { CasesComponent } from './cases/cases.component';
import { ShowNasrocheniDelaComponent } from './show-nasrocheni-dela/show-nasrocheni-dela.component';
import { ShowZadachiComponent } from './show-zadachi/show-zadachi.component';

import { LoginComponent } from './login/login.component';

import { PersonComponent } from './person/person.component';
import { AuthService } from './services/auth.service';
import { Routes } from '@angular/router';
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { SecurityUsersComponent } from './components/security-users/security-users.component';
import { StatusComponent } from './components/statuses/statuses.component';
import { NotificationConfigComponent } from './components/notification-config/notification-config.component';
import { AdminComponent } from './components/admin/admin.component';
import { MyCalendarComponent } from './my-calendar/my-calendar.component';
import { ExternalCasesComponent } from './external-cases/external-cases.component';



export const routes: Routes = [
	{
		path: 'login',
		component: LoginComponent
	},
	{
		path: 'cases',
		component: CasesComponent,
		canActivate: [AuthService]
	},
	{
		path: 'persons',
		component: PersonComponent,
		canActivate: [AuthService]
	},
	{
		path: 'ncases',
		component: ShowNasrocheniDelaComponent,
		canActivate: [AuthService]
	},
	{
		path: 'nzadachi',
		component: ShowZadachiComponent,
		canActivate: [AuthService]
	},
	{
		path: 'calendar',
		component: MyCalendarComponent,
		canActivate: [AuthService]
	},
	{
		path: 'ext-cases',
		component: ExternalCasesComponent,
		canActivate: [AuthService]
	},
	{
		path: 'change-password',
		component: ChangePasswordComponent,
		canActivate: [AuthService]
	},
	{
		path: 'admin',
		component: AdminComponent,
		canActivate: [AuthService]
	},
	{
		path: 'logout',
		redirectTo: '/login',
		canActivate: [AuthService]
	},
	{
		path: '',
		redirectTo: '/login',
		pathMatch: 'full'
	},
	{
		path: '**',
		redirectTo: '/login',
		pathMatch: 'full'
	}
];